import { requireStates } from "util";
import { ConnectComponent2 } from "util";
import View from "./list/view";
import Presenter from "./list/presenter";

const initialStates = [
  {
    name: "app.registration.discount",
    url: "/descontos",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    },
    data: {
      navigation: {
        priority: 800,
        name: "Descontos",
        state: "app.registration.discount"
      },
      authorization: () => true
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);
export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/discount/index.js